import { render, staticRenderFns } from "./ResourceCenter.vue?vue&type=template&id=0e43affd&"
import script from "./ResourceCenter.vue?vue&type=script&lang=js&"
export * from "./ResourceCenter.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports